<div class="panel-body">
  <div id="print-map">
    <div class="polygon-print page-break">
      <div class="title-recomendacoes">Mapa de distribuição das cultivares</div>
      <svg class="polygons" ng-bind-html="recomendacaoSemeadura.svgPolygons" xmlns="http://www.w3.org/2000/svg" version="1.1"
        id="svg-polygons" width="1000px" height="700px">
      </svg>
      <agro-legenda-mapa legendas="recomendacaoSemeadura.mapLegend" print-mode="true"/>
    </div>
  </div>
</div>
